'use strict';

// Static Methods
require('./escape');

// Instance Methods
require('./addFlags');
require('./getFlags');
require('./removeFlags');
require('./setFlags');

module.exports = require('sugar-core');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/regexp/index.js
// module id = 881
// module chunks = 0